import React, { useEffect } from 'react';

// reusable
import { ClearFilters, DirectoryPaging } from '/src/pages/directories/components';
import MagnittLoader from '/src/MicroFrontends/MagnittLoader';

// constants
import { MAGNITT_ACCESS_ROLES } from '/src/lib/constants/userRoles';
import AppMagnittLoader from '/src/components/Reusable/AppMagnittLoader';


/* this component displays magnitt loader / pagination / no results msg as needed */

const DirectoryFooter = (props) => {

    const { data, clearFilter, showTestData, user, count, isCustomMarketMap, removeSkeletonTable, tabIsVisible, setState, hasError } = props;
    const hasAccess = (user.is_loggedin && (user.roles.includes(MAGNITT_ACCESS_ROLES.directory_access) || user.roles.includes(MAGNITT_ACCESS_ROLES.limited_directory_access)));

    useEffect(() => {
        if (data && data.length === 0 && !removeSkeletonTable) {
            setState({
                removeSkeletonTable: true
            });
        }
    }, [data]);

    useEffect(() => {
        if (hasError) {
            console.error('DirectoryFooter: the list could not be loaded, so neither paging nor "no results" is shown');
        }
    }, [hasError]);

    if (showTestData) {
        return (null);
    }
    // magnitt loader
    else if (!removeSkeletonTable && tabIsVisible) {
        return (
            <div className="main-content-loader">
                <AppMagnittLoader
                    data={{
                        height: '695.6px',
                        background: 'transparent',
                        padding: '0'
                    }}
                />
            </div>
        )
    }
    else if (removeSkeletonTable && data === false) {
        return (<MagnittLoader data={{ height: "300px", background: "#FFF" }} />)
    }
    // the list could not be loaded: the page shows its own message, so neither "no results" nor paging
    else if (hasError) {
        return (null);
    }
    // no results msg
    // avoid showing in custom market map view, as a different message will be visible
    else if (!data?.length && !isCustomMarketMap) {
        return (
            <ClearFilters clearFilter={clearFilter} />
        )
    }

    // pagination
    else if (hasAccess && (data.length <= count)) {
        return (
            <DirectoryPaging
                // funcs
                filterValues={props.filterValues}
                setState={props.setState}
                // passed values
                page={props.page}
                count={count}
                limit={props.limit}
                loadingDirPage={props.loadingDirPage}
                allowNavigateWhileLoading={props.allowNavigateWhileLoading}
                tempFilter={props.tempFilter}
            />
        )
    }

    else {
        return (null);
    }

};

export default DirectoryFooter;
